<template>

    <trax-ui-card :title="lang.polaris.dashboard.flight_information">
        <div class="row">
            <div class="col-xl-6">
                <p>
                    <strong>
                        <i class="material-icons align-middle" style="transform: rotate(0.25turn)">flight</i> 
                        {{ lang.polaris.common.aircraft_type }}: 
                    </strong>
                    {{ aircraftType }}
                </p>
                <p>
                    <strong>
                        <i class="material-icons align-middle" style="transform: rotate(0.25turn)">flight</i> 
                        {{ lang.polaris.common.aircraft_category }}: 
                    </strong>
                    {{ aircraftCategory }}
                </p>
                <p>
                    <strong>
                        <i class="material-icons align-middle" style="transform: rotate(0.25turn)">flight</i> 
                        {{ lang.polaris.common.aircraft_registration }}: 
                    </strong>
                    {{ aircraftRegistration }}
                </p>
            </div>
            <div class="col-xl-6">
                <p>
                    <strong>
                        <i class="material-icons align-middle">query_builder</i> 
                        {{ lang.polaris.dashboard.flight_time }}: 
                    </strong>
                    {{ flightTime }}
                </p>
                <p>
                    <strong>
                        <i class="material-icons align-middle">flight_land</i> 
                        {{ lang.polaris.dashboard.tag_landing }}: 
                    </strong>
                    {{ tagLanding }}
                </p>
            </div>
        </div>
    </trax-ui-card>
    
</template>

<script>
    export default {

        data: function() {
            return {
                lang: lang,
                aircraft_types_names: data.aircraft_types_names,
                aircraft_categories_names: data.aircraft_categories_names,
                state: data.state
            }
        },

        computed: {

            aircraftType() {
                if (!this.state || !this.state.aircraft_type) return '';
                return this.aircraft_types_names[this.state.aircraft_type];
            },

            aircraftCategory() {
                if (!this.state || !this.state.aircraft_category) return '';
                return this.aircraft_categories_names[this.state.aircraft_category];
            },

            aircraftRegistration() {
                if (!this.state || !this.state.aircraft_registration) return '';
                return this.state.aircraft_registration;
            },

            flightTime() {
                if (!this.state || !this.state.duration) return '';
                return this.state.duration;
            },

            tagLanding() {
                if (!this.state || !this.state.tag_landing) return '';
                return this.state.tag_landing;
            }

        }

    }
</script>
